<div
	class="d-flex justify-content-between flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-primary text-white border-bottom box-shadow"
>
	<div class="d-flex align-items-center" routerLink="">
		<img class="logo" src="../../assets/images/logo.svg" />
	</div>

	<div class="d-flex align-items-center gap-3">
		<div class="dropdown" *ngIf="recentHistory().length > 0">
			<button
				class="btn btn-sm btn-outline-light dropdown-toggle"
				type="button"
				data-bs-toggle="dropdown"
				aria-expanded="false"
			>
				<i class="bi-clock-history me-1"></i>
				Valutazioni recenti
				<span class="badge bg-light text-primary ms-1">{{ recentHistory().length }}</span>
			</button>
			<ul class="dropdown-menu dropdown-menu-end" style="min-width: 320px; z-index: 1030;">
				<li *ngFor="let entry of recentHistory()">
					<button
						type="button"
						class="dropdown-item d-flex flex-column text-body"
						style="white-space: normal;"
						(click)="goToHistoryEntry(entry.id)"
					>
						<div class="d-flex align-items-center mb-1">
							<span
								class="badge me-2"
								[class.bg-success]="entry.outcome === 'idoneo'"
								[class.bg-danger]="entry.outcome === 'non_idoneo'"
							>
								{{ entry.outcome === 'idoneo' ? 'Idoneo' : 'Non idoneo' }}
							</span>
							<strong class="text-dark">{{ entry.courseLabel }}</strong>
						</div>
						<small class="text-muted">{{ entry.savedAt | date:'dd/MM/yyyy HH:mm' }}</small>
					</button>
				</li>
				<li><hr class="dropdown-divider" /></li>
				<li>
					<button type="button" class="dropdown-item text-danger" (click)="clearHistory()">
						<i class="bi-trash me-1"></i> Pulisci cronologia
					</button>
				</li>
			</ul>
		</div>

		<span>{{ user.email }}</span>
	</div>
</div>
